import { Theme } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme: Theme) => ({
  buttons: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: theme.spacing(2),
    '& .MuiBox-root button:last-child': {
      marginLeft: theme.spacing(2),
    },
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      '& .MuiBox-root': {
        justifyContent: 'space-between',
      },
      '& button:first-child': {
        width: '100%',
        marginBottom: theme.spacing(2),
      },
      '& .MuiBox-root button': {
        width: '45%',
        marginRight: theme.spacing(1),
      },
      '& .MuiBox-root button:last-child': {
        marginRight: 0,
      },
    },
    [theme.breakpoints.down(1190)]: {
      marginTop: 0,
    },
  },
  tableContainer: {
    [theme.breakpoints.down('md')]: {
      '& td': {
        padding: '5px',
      },
    },
  },
  tablePaperContainer: {
    width: '20vw',
    overflow: 'hidden',
    height: '100%',
    maxHeight: 'calc(100vh - 200px)',
    [theme.breakpoints.down('md')]: {
      width: '100%',
      height: 'auto',
      maxHeight: '400px',
      marginBottom: theme.spacing(2),
    },
  },
  tableQuestionAnswers: {
    height: '100%',
    overflowY: 'auto',
    '&::-webkit-scrollbar': {
      display: 'none',
    },
    '&::-webkit-scrollbar-thumb': {
      display: 'none',
    },
    [theme.breakpoints.down('md')]: {
      maxHeight: '400px',
    },
  },
  tableCellPrimaryBackgroundColor: {
    backgroundColor: theme.palette.background.main,
  },
  tableRowAnswerBase: {
    height: '59px',
    '&:hover': {
      cursor: 'pointer',
      backgroundColor: 'rgb(242, 172, 50, 0.30)',
    },
  },
  tableRowAnswerNotAnswered: {
    backgroundColor: 'rgb(242, 172, 50, 0.15)',
  },
  questionsContainer: {
    display: 'flex',
    alignItems: 'stretch',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column-reverse',
    },
  },
  questionContainer: {
    padding: '10px 0 0 10px',
    height: 'calc(100vh - 400px)',
    overflowY: 'auto',
    backgroundColor: 'white',
    marginBottom: theme.spacing(2),
    '&::-webkit-scrollbar': {
      display: 'none',
    },
    '&::-webkit-scrollbar-thumb': {
      display: 'none',
    },
    [theme.breakpoints.down('md')]: {
      overflow: 'auto',
      marginTop: '20px',
      height: 'fit-content',
    },
  },
  questionAndButtonsContainer: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    marginLeft: theme.spacing(2),
    [theme.breakpoints.down('md')]: {
      marginLeft: 0,
    },
  },
  currentQuestion: {
    backgroundColor: 'rgb(242, 172, 50, 0.60)',
    '& .MuiTableCell-root': {
      fontWeight: 600,
    },
  },
}));

export default useStyles;
